import React , {Component} from 'react';
import AUX from '../../hoc/Aux_';
import Grid from '@material-ui/core/Grid';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import {fetchUnsurCode, fetchKategori } from '../../api/kugi';
import TablePropertyType from '../../components/Kugi/tablePropertyType'
import BorderColor from '@material-ui/icons/BorderColor';
import ArrowBack from '@material-ui/icons/ArrowBackIos';
import { Alert, AlertTitle } from '@material-ui/lab';
import { Link } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import Config from "../../config/";
const ROOT_URL = Config.rooturl;
class PencarianDetail extends Component {

  constructor(props) {
    super(props);
    this.state = {
      featureType : [],
      search: "",
      id: this.props.match.params.id,
      featureTypeID:"",
      fcid:1,
      code:"",
      typeName:"",
      attribute_is_abstract:"",
      bf_attribute:"",
      date:"",
      definition:"",
      featureCatalogue:"",
      featureCatalogueId:"",
      definition:"",
      aliases:"",
      fcDefinitionSource:"",
      inheritanceSubtype:"",
      inheritanceSupertype:"",
      inheritanceDescription:"",
      inheritanceName:"",
      fcDefinitionReference:"",
      attributeIsAbstract:"",
      fcConstraint:"",
      fcFeatureAssociation:"",
      feature_catalogue:"",
      fcAssociationRole:"",
      fcFeatureOperation:"",
      date:"",
      attributVersionNumber:"",
      fcProducer:"",
      role:"",
      faCode:"",
      faValueMeasurementUnit:"",
      faValueType:"",
      fcDefinitionReference1:"",
      fcProducer1:"",
      bfAtribute:"",
    }
  }

  componentWillMount(){
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const foo = params.get('code');
    const foo2 = params.get('fcid');
    this.setState({fcid:foo2, code:foo});

    let unsurx = [];

    console.log(foo2);

    fetchUnsurCode(foo2, foo)
      .then(response => {
        response.data.map((a)=>{

          console.log(a.attributVersionNumber.replace("@en", ""));

          this.setState({featureTypeID: a.featureTypeID.replace("@en", "")});
          this.setState({code: a.code.replace("@en", "")});
          this.setState({typeName: a.typeName.replace("@en", "")});
          this.setState({featureCatalogue: a.featureCatalogue.replace("@en", "")});
          this.setState({definition: a.definition.replace("@en", "")});
          this.setState({aliases: a.aliases.replace("@en", "")});
          this.setState({fcDefinitionSource: a.fcDefinitionSource.replace("@en", "")});
          this.setState({inheritanceSubtype: a.inheritanceSubtype.replace("@en", "")});
          this.setState({inheritanceSupertype: a.inheritanceSupertype.replace("@en", "")});
          this.setState({faCoinheritanceDescriptionde: a.inheritanceDescription.replace("@en", "")});
          this.setState({inheritanceName: a.inheritanceName.replace("@en", "")});
          this.setState({fcName: a.fcName.replace("@en", "")});
          this.setState({fcDefinitionReference: a.fcDefinitionReference.replace("@en", "")});
          this.setState({attributeIsAbstract: a.attributeIsAbstract.replace("@en", "")});

          this.setState({fcFeatureAssociation: a.fcFeatureAssociation.replace("@en", "")});
          this.setState({fcAssociationRole: a.fcAssociationRole.replace("@en", "")});
          this.setState({fcFeatureOperation: a.fcFeatureOperation.replace("@en", "")});
          this.setState({date: a.date.replace("@en", "")});
          this.setState({attributVersionNumber: a.attributVersionNumber.replace("@en", "")});
          this.setState({fcProducer: a.fcProducer.replace("@en", "")});
          this.setState({role: a.role.replace("@en", "")});

        });

      }).catch(error => {
        console.log(error);
      });

  }

  render(){
    return (
      <AUX>
        <section className="sections" style = {{paddingTop:"5%"}}>
          <div className="container">
          <Grid item xs={12} >
          <Alert severity="info"
          action={
            <Button color="inherit" size="small"><a href= {`${ROOT_URL}featuretypegetbycode?code=${this.state.code}`} target="_blank">Akses API</a> </Button>
          }

          > <Link to = "pencarianbig">
          <ArrowBack/> Kembali ke hasil pencarian</Link>
          <span style =
          {{position: 'absolute',
            right: 350,
            width: 200,
            height: 120}}
          >

          </span>
          </Alert>
          <Paper style = {{padding:10}}>

          <TableContainer  >
            <Table aria-label="simple table">
              <TableBody>
                <TableRow key={1}>
                  <TableCell component="th" scope="row" style = {{borderBottom: "none" }}>
                    <b>Kode Unsur</b>
                  </TableCell>
                  <TableCell style = {{borderBottom: "none", paddingLeft: 100}}>{this.state.code}</TableCell>
                </TableRow>
                <TableRow key={2}>
                  <TableCell component="th" scope="row" style = {{borderBottom: "none" }}>
                    <b>Nama Unsur</b>
                  </TableCell>
                  <TableCell style = {{borderBottom: "none", paddingLeft: 100 }}>{this.state.typeName}</TableCell>
                </TableRow>
                <TableRow key={5}>
                  <TableCell component="th" scope="row" style = {{borderBottom: "none"}}>
                    <b>Katalog Unsur</b>
                  </TableCell>
                  <TableCell style = {{borderBottom: "none", paddingLeft: 100}}>{this.state.featureCatalogue}</TableCell>
                </TableRow>
                <TableRow key={3}>
                  <TableCell component="th" scope="row" style = {{borderBottom: "none"}}>
                    <b>Definisi</b>
                  </TableCell>
                  <TableCell style = {{borderBottom: "none", paddingLeft: 100}}>{this.state.definition}</TableCell>
                </TableRow>
                <TableRow key={4}>
                  <TableCell component="th" scope="row" style = {{borderBottom: "none"}}>
                    <b>Nama Alias</b>
                  </TableCell>
                  <TableCell style = {{borderBottom: "none", paddingLeft: 100}}>{this.state.aliases}</TableCell>
                </TableRow>
                <TableRow key={6}>
                  <TableCell component="th" scope="row" style = {{borderBottom: "none"}}>
                    <b>Sumber Definisi</b>
                  </TableCell>
                  <TableCell style = {{borderBottom: "none", paddingLeft: 100}}>{this.state.fcDefinitionSource}</TableCell>
                </TableRow>
                <TableRow key={8}>
                  <TableCell component="th" scope="row" style = {{borderBottom: "none"}}>
                     <b>Inheritance Sub type</b>
                  </TableCell>
                  <TableCell style = {{borderBottom: "none", paddingLeft: 100}}>{this.state.inheritanceSubtype}</TableCell>
                </TableRow>
                <TableRow key={9}>
                  <TableCell component="th" scope="row" style = {{borderBottom: "none"}}>
                    <b>Inheritance Super type</b>
                  </TableCell>
                  <TableCell style = {{borderBottom: "none", paddingLeft: 100}}>{this.state.inheritanceSupertype}</TableCell>
                </TableRow>
                <TableRow key={10}>
                  <TableCell component="th" scope="row" style = {{borderBottom: "none"}}>
                    <b>Inheritance Description</b>
                  </TableCell>
                  <TableCell style = {{borderBottom: "none", paddingLeft: 100}}>{this.state.inheritanceDescription}</TableCell>
                </TableRow>
                <TableRow key={11}>
                  <TableCell component="th" scope="row" style = {{borderBottom: "none"}}>
                    <b>Inheritance Name</b>
                  </TableCell>
                  <TableCell style = {{borderBottom: "none", paddingLeft: 100}}>{this.state.inheritanceName}</TableCell>
                </TableRow>
                <TableRow key={12}>
                  <TableCell component="th" scope="row" style = {{borderBottom: "none"}}>
                    <b>Referensi Definisi</b>
                  </TableCell>
                  <TableCell style = {{borderBottom: "none", paddingLeft: 100}}>{this.state.fcDefinitionReference}</TableCell>
                </TableRow>
                <TableRow key={13}>
                  <TableCell component="th" scope="row" style = {{borderBottom: "none"}}>
                    <b>Abstrak</b>
                  </TableCell>
                  <TableCell style = {{borderBottom: "none", paddingLeft: 100}}>{this.state.attributeIsAbstract}</TableCell>
                </TableRow>
                <TableRow key={14}>
                  <TableCell component="th" scope="row" style = {{borderBottom: "none"}}>
                    <b>Versi Katalog</b>
                  </TableCell>
                  <TableCell style = {{borderBottom: "none", paddingLeft: 100}}>{this.state.attributVersionNumber}</TableCell>
                </TableRow>

                <TableRow key={16}>
                  <TableCell component="th" scope="row" style = {{borderBottom: "none"}}>
                    <b>Asosiasi Unsur</b>
                  </TableCell>
                  <TableCell style = {{borderBottom: "none", paddingLeft: 100}}>{this.state.fcFeatureAssociation}</TableCell>
                </TableRow>
                <TableRow key={17}>
                  <TableCell component="th" scope="row" style = {{borderBottom: "none"}}>
                    <b>Association Role</b>
                  </TableCell>
                  <TableCell style = {{borderBottom: "none", paddingLeft: 100}}>{this.state.fcAssociationRole}</TableCell>
                </TableRow>
                <TableRow key={18}>
                  <TableCell component="th" scope="row" style = {{borderBottom: "none"}}>
                    <b>Operasi Unsur</b>
                  </TableCell>
                  <TableCell style = {{borderBottom: "none", paddingLeft: 100}}>{this.state.fcFeatureOperation}</TableCell>
                </TableRow>
                <TableRow key={19}>
                  <TableCell component="th" scope="row" style = {{borderBottom: "none"}}>
                    <b>Tahun Katalog</b>
                  </TableCell>
                  <TableCell style = {{borderBottom: "none", paddingLeft: 100}}>{this.state.date}</TableCell>
                </TableRow>

                <TableRow key={20}>
                  <TableCell component="th" scope="row" style = {{borderBottom: "none"}}>
                    <b>Produsen Katalog</b>
                  </TableCell>
                  <TableCell style = {{borderBottom: "none", paddingLeft: 100}}>{this.state.fcProducer}</TableCell>
                </TableRow>
                <TableRow key={21}>
                  <TableCell component="th" scope="row" style = {{borderBottom: "none"}}>
                    <b>Peran/Wewenang</b>
                  </TableCell>
                  <TableCell style = {{borderBottom: "none", paddingLeft: 100}}>{this.state.role}</TableCell>
                </TableRow>



              </TableBody>
            </Table>
        </TableContainer>
        </Paper>
        <br/>
        <TablePropertyType code = {this.state.code} fcid = {this.state.fcid}/>
          </Grid>
          <div className="container">
              <div className="row justify-content-center" id="counter"/>
          </div>
        </div>
        </section>
      </AUX>
    )
  }

}

export default PencarianDetail;
